import yup from "lib/yup-extended";

export const validations = yup.object({
  selectedProducts: yup
    .array()
    .test(
      "at-least-one-selection",
      "Selecione pelo menos uma solução.",
      function (value) {
        const { selectedProducts, interestPlan } = this.parent;
        const hasSelection =
          (selectedProducts && selectedProducts.length > 0) ||
          (interestPlan && interestPlan.length > 0);
        return hasSelection;
      }
    ),
  interestPlan: yup.array(),
});
